<style type="text/css" media="screen" scoped>
.input-block{
  border: 1px solid #E2E2E2;
  box-sizing: border-box;
  border-radius: 6px;
  width: 38px;
  height: 38px;
  padding: 10px;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #303030;
}
.input-block:focus{
  border: 2px solid #1DC895 !important;
  /*background-color: #1DC895;*/
  /*color: #FFFF;*/
}
.input-block-wrapper{
  width: 45px;
  height: 45px;
  display: inline-block;
}
</style>

<template>
 <div class="text-center">
   <v-dialog v-model="dialog.flag" persistent width="520" class="br-25" >
    <v-card>
      <!--  close btn -->
      <p class="text-right pr-3" style="margin-bottom:-10px !important">
        <v-icon color="#8F8F8F" small @click="dialog.flag=false">
          mdi-window-close
        </v-icon>
      </p>
      <v-card-text class="flex-column  mb-5 ">
        <!--  dialog title -->
        <p class="page-title text-center">{{$lang.VERIFICATION.toUpperCase()}}</p>
        <div class="mt-8">
          <v-row class="">
            <v-col md="6" class="pt-0" v-if="dialog.item.wholesaler_firm_name">
              <p class="secodry-text-2">{{$lang.WHOLESALER}}</p>
              <p class="sub-title-text">{{dialog.item.wholesaler_firm_name}}</p>
            </v-col>
            <v-col md="6" class="pt-0">
              <div class="d-flex flex-row pt-0 text-left"  flat >
                <div>
                  <img src="@/assets/calender.svg"  alt="img"  width="18px" class="mt-5">
                </div>
                <div class="pa-2 pt-0">
                  <p class="secodry-text-2">{{$lang.DATE}}</p>
                  <p class="sub-title-text text-center">{{dialog.item.date}}, {{dialog.item.time}}</p>
                </div>
              </div>
            </v-col>
          </v-row >
          <v-row >
            <v-col md="8" class="pt-0">
              <p class="filter-sub-title">{{$lang.AMOUNT}}</p>
              <p class="sub-title-text">
                <img src="@/assets/rupee.svg"  alt="img"  width="11px" class="" style="margin-right:-5px">
                {{dialog.item.amount}}
              </p>
            </v-col>
            <v-col md="4" class="pt-0">
              <div class="d-flex flex-row pt-0">
                <div>
                  <img src="@/assets/return-green.svg"  alt="img"  width="18px" class="mt-5">
                </div>
                <div class="pa-2 pt-0"  >
                  <p class="secodry-text-2">{{$lang.RETURNS}}</p>
                  <p class="sub-title-text text-center">{{dialog.item.returned_count}}</p>
                </div>
              </div>
            </v-col>
            <v-col md="7" class="py-0" v-if="$store.state.user_type!=$keys.WHOLESALER">
              <p class="secodry-text-2 pb-2">{{$lang.RECIPIENT_NAME}}</p>
              <v-text-field
              v-model="recipient_name"
              :placeholder="$lang.RECIPIENT_NAME"
              outlined
              dense
              single-line
              :rules="$rules.RECIPIENT_NAME"

              ></v-text-field>
            </v-col>
          </v-row >
          <div class="text-left mt-2"> 
            <p class="secodry-text-2 mb-1">{{$lang.OTP.toUpperCase()}}</p>

            <otp-block  input-classes="small-input-block" @on-complete="getOtp"/>
          </div>
          <p class="messge-text-green cursor-pointer text-left mt-2" @click="resendOtp">{{$lang.RESEND_TO}}{{dialog.item.mobile}}</p>
          <p>{{dialog.otp}}</p>
        </div>
      </v-card-text>
      <v-card-actions class="text-center pb-5">
        <v-spacer></v-spacer>
        <v-btn color="primary" width="90" class="fw-bold ml-5" 
        :disabled="otp.length!=6?true:false"
        :loading="btn_loading"   @click="verifyWithdraw">  
        {{$lang.CONTINUE}}
      </v-btn>  
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>
</template>


<script>
export default {
  props:["dialog"],
  components: {
    OtpBlock: () => import('@/components/common-components/opt-input-box/OtpBlock.vue'),
  },
  data () {
    return {
      recipient_name:"",
      btn_loading:false,
      otp:"",

    }
  },
  methods: {
    /* get otp from the data*/ 
    getOtp(otp){
      this.otp=otp
    },

    /* Verify Withdrawal an dgenerate reqest to warehouse  */ 
    verifyWithdraw(){
      const self=this;
      self.btn_loading=true
      if(this.$store.state.user_type!=this.$keys.WHOLESALER){
        if (this.recipient_name==null||this.recipient_name==""||this.recipient_name.length==0){
          this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:"Recipient name is required", color:"warning" })
          return false
        }
      }
      

      var form = new FormData();
      form.append("otp",this.otp);
      form.append("recipient_name",self.recipient_name);

      var header={
        'otp-token':this.dialog.item.otp_token,
        'token':sessionStorage.getItem("token"),
      }
      const successHandler = (response) => {
        if (response.data.success){
          this.dialog.flag=false
          this.$router.push({name:'withdrawal-details',params:{transaction_id:this.encript(response.data.id)}})
        }
      };
      const finallyHandler = () => {
        self.btn_loading=false
      };
      this.request_POST(self,self.$urls.VERIFY_WITHDRAW,form,successHandler,header,null,finallyHandler) 

    },
    /* resend otp*/ 
    resendOtp(){
      const self=this;
      var  form = new URLSearchParams();
      var header={
        'otp-token':this.dialog.item.otp_token,
      }
      const successHandler = (response) => {
        if (response.data.success){
          let text="OTP resent"
          this.$store.dispatch('snackbar/setSnackbar', {flag:true, text, color:"success" })
        }
      };
      self.request_GET(self,self.$urls.WITHDRAW_RESEND_OTP,form,successHandler,header)

    }



  }
}
</script>